import { memo } from "react";
import { useAbsencesCalendarContext } from "./context";
import type { AbsencesCalendarCell } from "./use-absences-calendar";

/** Props Interface */
interface AbsencesCalendarHeaderYearItemProps {
	cell: AbsencesCalendarCell;
}

function AbsencesCalendarHeaderYearItemImpl({ cell }: AbsencesCalendarHeaderYearItemProps) {
	/** Context */
	const { controller } = useAbsencesCalendarContext();

	/** Functions */
	function handleOnClick() {
		controller.setMode("month");
		controller.setCurrent(cell.cellMoment);
	}

	/** Render */
	return (
		<div
			className="v-stack w-full h-full flex-center gap-0 items-center *:text-xs cursor-pointer"
			onClick={handleOnClick}
		>
			<p>{cell.cellMoment.format("W")}</p>
		</div>
	);
}

export const AbsencesCalendarHeaderYearItem = memo(AbsencesCalendarHeaderYearItemImpl);
